import React from 'react'
import Box from '@ui/Box'
import { Checkbox } from 'antd'
import { Color } from '@interfaces/designSystem'
import { ElementsType } from '@enhanci/enhanci-lib'

type Props = {
  onChange: (elements: ElementsType[]) => void
  value: ElementsType[]
}

const options = [
  { label: 'Pricing table', value: 'pricing' },
  { label: 'Compare plans table', value: 'compare' },
  { label: 'FAQ section', value: 'faq' },
]

const ElementsSelector = ({ onChange, value }: Props) => {
  return (
    <Box pt={12}>
      <Box pb={8}>
        Select widgets that you would like to show on your website and then copy the code
        and paste it to your website. You don't need to publish the widget every time you
        want to select different options. But you might need to re-publish the widget once
        if it's an old widget.
      </Box>
      <Box p={16} border={`1px solid ${Color.Grey_10}`} borderRadius={8}>
        <Checkbox.Group options={options} onChange={onChange} value={value} />
      </Box>
    </Box>
  )
}

export default ElementsSelector
